export const API = "https://nerdstoreapi.herokuapp.com/api";
